"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchDealerVehicles = exports.removeMatchingDealerVehicleIds = exports.setMatchingDealerVehicleIds = exports.REMOVE_MATCHING_DEALER_VEHICLE_IDS = exports.SET_MATCHING_DEALER_VEHICLE_IDS = exports.FETCH_MATCHING_DEALER_VEHICLES = exports.MATCHING_VEHICLES_FROM_DEALER = void 0;
exports.MATCHING_VEHICLES_FROM_DEALER = '[matching Vehicles from the current Dealer]';
exports.FETCH_MATCHING_DEALER_VEHICLES = `${exports.MATCHING_VEHICLES_FROM_DEALER} FETCH`;
exports.SET_MATCHING_DEALER_VEHICLE_IDS = `${exports.MATCHING_VEHICLES_FROM_DEALER} SET`;
exports.REMOVE_MATCHING_DEALER_VEHICLE_IDS = `${exports.MATCHING_VEHICLES_FROM_DEALER} DELETE`;
const fetchDealerVehiclesAction = ({ query }) => ({
    type: exports.FETCH_MATCHING_DEALER_VEHICLES,
    payload: query,
    meta: { feature: exports.MATCHING_VEHICLES_FROM_DEALER },
});
const setMatchingDealerVehicleIds = ({ vehicleIds }) => ({
    type: exports.SET_MATCHING_DEALER_VEHICLE_IDS,
    payload: vehicleIds,
    meta: { feature: exports.MATCHING_VEHICLES_FROM_DEALER },
});
exports.setMatchingDealerVehicleIds = setMatchingDealerVehicleIds;
const removeMatchingDealerVehicleIds = () => ({
    type: exports.REMOVE_MATCHING_DEALER_VEHICLE_IDS,
    payload: [],
    meta: { feature: exports.MATCHING_VEHICLES_FROM_DEALER },
});
exports.removeMatchingDealerVehicleIds = removeMatchingDealerVehicleIds;
const fetchDealerVehicles = ({ query }) => (dispatch, getState, svdModel) => svdModel.then(() => dispatch(fetchDealerVehiclesAction({ query })));
exports.fetchDealerVehicles = fetchDealerVehicles;
//# sourceMappingURL=matchingVehiclesFromDealer.js.map